// Special keys that get custom UI rendering on the frontend
export const SPECIAL_SECTION_KEYS = ["category", "authors"];

export function normalizeHomepageSections(rawSections) {
    if (!rawSections || typeof rawSections !== "object") return {};

    const normalized = {};

    for (const key of Object.keys(rawSections)) {
        const incoming = rawSections[key] || {};
        const bookIds = Array.isArray(incoming.bookIds)
            ? [...new Set(incoming.bookIds.map((bookId) => String(bookId ?? "").trim()).filter(Boolean))]
            : [];
        const parsedLimit = Number(incoming.itemLimit);

        normalized[key] = {
            sectionKey: key,
            label: incoming.label || key,
            description: incoming.description || "",
            sortOrder: Number(incoming.sortOrder) || 0,
            itemLimit: Number.isFinite(parsedLimit) && parsedLimit > 0
                ? Math.floor(parsedLimit)
                : 8,
            bookIds,
            isActive: incoming.isActive !== undefined ? Boolean(incoming.isActive) : true,
        };
    }

    // Ensure special keys exist even if deleted from DB
    if (!normalized["category"]) {
        normalized["category"] = { sectionKey: "category", label: "Explore By Category", description: "Books available inside the category section tabs.", sortOrder: -2, itemLimit: 5, bookIds: [], isActive: true };
    }
    if (!normalized["authors"]) {
        normalized["authors"] = { sectionKey: "authors", label: "Featured Authors", description: "Authors shown in the Author section.", sortOrder: -1, itemLimit: 10, bookIds: [], isActive: true };
    }

    return normalized;
}

export function buildManualSectionBooks(allBooks = [], sectionConfig = {}) {
    const ids = Array.isArray(sectionConfig.bookIds) ? sectionConfig.bookIds : [];
    if (!ids.length) return [];

    const byId = new Map(
        allBooks.map((book) => [String(book?._id ?? book?.id ?? ""), book])
    );

    return ids
        .map((id) => byId.get(String(id)))
        .filter(Boolean);
}
